var map = {
	"./fonts/NunitoSans/NunitoSans-Regular.ttf": 81,
	"./icons/admin-page.svg": 143,
	"./icons/apple_app-store.svg": 144,
	"./icons/google_play-store.svg": 145,
	"./icons/web-desktop.svg": 146,
	"./logos/applications/AssessmentHub.svg": 147,
	"./logos/applications/Dyalog.svg": 148,
	"./logos/applications/LearningHub.svg": 149,
	"./logos/applications/Odyssey.svg": 150,
	"./logos/applications/Podquest.svg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;